import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    BreadcrumbShowCountlabel,
    commonPageField,
    commonPageFieldSuccess,
    goButtonPartyItemAddPage,
    goButtonPartyItemAddPageSuccess,
} from "../../../store/actions";
import * as apiCall from "../../../helpers/backend_helper"
import * as pageId from "../../../routes/allPageID";
import { Button, Col, FormGroup, Input, Label, Table } from "reactstrap";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import { C_DatePicker, C_Select, CInput, decimalRegx, decimalRegx_3dit } from "../../../CustomValidateForm";
import * as _cfunc from "../../../components/Common/CommonFunction";
import { MetaTags } from "react-meta-tags";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

import GlobalCustomTable from "../../../GlobalCustomTable";
import { PageLoadingSpinner, SaveButton } from "../../../components/Common/CommonButton";
import SaveButtonDraggable from "../../../components/Common/saveButtonDraggable";
import { mode, url } from "../../../routes";
import { deleteWastageId, updateWastageList, wastageSave, wastageSaveSuccess, wastageSingleGetSuccess } from "../../../store/Inventory/WastageEntryMasterRedux/action";
import { Thead, Tbody } from "react-super-responsive-table";
import { innerStockCaculation, return_discountCalculate_Franchise, return_discountCalculate_Func, returnQtyOnChange, stockQtyOnChange } from "../../Purchase/Return/PurchaseReturnCalculation";
import Select from "react-select";

const calculateGrandTotalFromGrid = (grid = []) =>
    Number(
        grid.reduce(
            (sum, r) => sum + Number(r.ItemTotalAmount || 0),
            0
        ).toFixed(2)
    );


const WastageEntryMaster = () => {

    const dispatch = useDispatch();
    const history = useHistory();
    const isSweetAndSnacks = _cfunc.IsSweetAndSnacksCompany()
    /* -------------------- HEADER STATE -------------------- */
    const [wastageDate, setWastageDate] = useState(_cfunc.currentDate_ymd);
    const [remarks, setRemarks] = useState("");
    const isFranchise = _cfunc.loginUserIsFranchisesRole()
    /* -------------------- ITEM STATES -------------------- */
    const [selectedItem, setSelectedItem] = useState(null);
    const [itemGrid, setItemGrid] = useState([]);
    const [showTable, setShowTable] = useState(false);
    /* -------------------- PAGE ACCESS -------------------- */
    const [userPageAccessState, setUserAccState] = useState("");
    const location = { ...history.location };

    const editBindDoneRef = useRef(false);
    const userChangedRef = useRef(false);
    const [addItemLoading, setAddItemLoading] = useState(false);
    /* -------------------- REDUX -------------------- */
    const reducers = useSelector((state) => ({
        goBtnLoading: state.wastageReducer.goBtnLoading,
        userAccess: state.Login.RoleAccessUpdateData,
        pageField: state.CommonPageFieldReducer.pageFieldList,
        Items: state.PartyItemsReducer.partyItem,
        commonPartyDropSelect: state.CommonPartyDropdownReducer.commonPartyDropSelect,
        loading: state.wastageReducer.loading,
        saveResponse: state.wastageReducer.saveResponse,
        editData: state.wastageReducer.editData,
        updateMsg: state.wastageReducer.updateMsg,
        deleteMsg: state.wastageReducer.deleteMsg,
        partyItemListLoading: state.PartyItemsReducer.partyItemListLoading
    }));

    const { Items = [], userAccess, pageField, goBtnLoading, commonPartyDropSelect, editData, saveResponse, updateMsg, deleteMsg, partyItemListLoading } = reducers;
    const isEditMode = !!editData?.Data?.id;
    const [forceReload, setForceReload] = useState(false);
    const [editId, setEditId] = useState(null);
    /* -------------------- EFFECTS -------------------- */
    useEffect(() => {
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(pageId.WASTAGE_ENTRY_MASTER));
        dispatch(BreadcrumbShowCountlabel(`Count:${0} currency_symbol ${0}`))
    }, []);

    useEffect(() => {
        if (!commonPartyDropSelect?.value) return;

        dispatch(
            goButtonPartyItemAddPage({
                jsonBody: JSON.stringify({
                    ..._cfunc.loginJsonBody(),
                    PartyID: commonPartyDropSelect.value
                })
            })
        );
        return () => {
            dispatch(goButtonPartyItemAddPageSuccess([]));
        }
    }, [commonPartyDropSelect?.value]);

    useEffect(() => {
        const userAcc = userAccess?.find(
            (inx) => `/${inx.ActualPagePath}` === location.pathname
        );
        if (userAcc) {
            setUserAccState(userAcc);
            _cfunc.breadcrumbReturnFunc({ dispatch, userAcc });
        }
    }, [userAccess]);

    // 🔑 Cache edit ID safely (DO NOT REMOVE)
    useEffect(() => {
        if (editData?.Data?.id) {
            setEditId(editData.Data.id);
        }
    }, [editData?.Data?.id]);


    useEffect(() => {
        if (saveResponse && saveResponse.StatusCode === 200) {
            dispatch(wastageSaveSuccess(null));
            history.push(url.WASTAGE_LIST);
        }
    }, [saveResponse]);

    useEffect(() => {
        if (updateMsg?.Status === true && updateMsg?.StatusCode === 200) {
            dispatch(wastageSingleGetSuccess({ Status: false })); // clear edit
            history.push(url.WASTAGE_LIST);              // ✅ SAME AS SAVE
        }
    }, [updateMsg]);

    useEffect(() => {
        if (deleteMsg?.Status === true && deleteMsg?.StatusCode === 200) {
            history.push(url.WASTAGE_LIST);
        }
    }, [deleteMsg]);


    useEffect(() => {
        if (!editData?.Data?.id) return;
        if (!commonPartyDropSelect?.value) return;
        if (editBindDoneRef.current) return;
        editBindDoneRef.current = true;

        const bindEditData = async () => {
            const data = editData.Data;

            // 🔹 Header
            setWastageDate(data.WastageDate);
            setRemarks(data.Remarks || "");

            const itemMap = {};

            for (const it of data.Items) {
                const MRPOptions = (it?.ItemMRPDetails || []).map(mrp => ({
                    value: mrp.MRP,
                    label: mrp.MRPValue,
                    Rate: mrp.Rate,
                }));
                const GSTOptions = (it?.ItemGSTDetails || []).map(gst => ({
                    value: gst.GST,
                    label: gst.GSTPercentage,
                }));
                const selectedGST = GSTOptions.find(
                    g => Number(g.value) === Number(it.GST)
                );
                const selectedMRP = MRPOptions.find(
                    o => Number(o.value) === Number(it.MRP)
                );
                const unit = (it.UnitDetails || []).find(
                    u => Number(u.UnitID) === Number(it.UnitID)
                );

                const baseRate = Number(selectedMRP?.Rate || it.Rate || 0);
                const unitRate = unit
                    ? Number(
                        (
                            (Number(unit.BaseUnitQuantity) /
                                Number(unit.BaseUnitQuantityNoUnit)) *
                            baseRate
                        ).toFixed(2)
                    )
                    : baseRate;
                const qty = Number(it.Quantity || 0);
                const rate = unitRate;
                const gstPer = Number(selectedGST?.label || selectedGST?.value || it.GSTPercentage || 0);
                const baseAmount = qty * rate;
                const gstAmount = (baseAmount * gstPer) / 100;
                const totalWithGST = Number((baseAmount + gstAmount).toFixed(2));
                const totalAmount = baseAmount + gstAmount;
                if (!itemMap[it.ItemID]) {
                    itemMap[it.ItemID] = {
                        id: it.ItemID,
                        ItemID: it.ItemID,
                        ItemName: it.ItemName,
                        UnitID: it.UnitID,
                        UnitName: it.UnitName,
                        UnitOptions: it.UnitDetails || [],
                        Quantity: Number.isFinite(Number(it.Quantity)) ? Number(it.Quantity) : 0,
                        Rate: unitRate,
                        BaseRate: baseRate,
                        ItemTotalAmount: totalWithGST,
                        ItemRemark: it.Remarks || "",
                        MRP: selectedMRP?.value || it.MRP,
                        MRPValue: selectedMRP?.label || it.MRPValue,
                        MRPOptions: MRPOptions,
                        GST: selectedGST?.value || it.GST,
                        GSTPercentage: selectedGST?.label || it.GSTPercentage,
                        GSTAmount: gstAmount.toFixed(2),
                        Amount: totalAmount.toFixed(2),
                        GSTOptions: GSTOptions,
                        StockDetails: (it.stock || []).map(b => ({
                            id: b.BatchId,
                            BatchCode: b.BatchNo,
                            BaseUnitQuantity: Number(b.BaseUnitQuantity || 0),
                            Qty: Number(b.Quantity || 0),
                            Rate: Number(b.Rate || it.Rate),
                        })),
                    };
                }
            }
            setItemGrid(Object.values(itemMap));
            setShowTable(true);
            setTimeout(() => setForceReload(v => !v), 0);
        };
        bindEditData()
        return () => {
            dispatch(wastageSingleGetSuccess({ Status: false }));
        };
    }, [editData?.Data?.id, commonPartyDropSelect?.value]);



    useEffect(() => {
        if (!editData?.Data?.id) {
            editBindDoneRef.current = false;
            userChangedRef.current = false;
        }
    }, [editData?.Data?.id]);

    /* -------------------- ITEM OPTIONS -------------------- */
    const Item = Items.map((index) => ({
        value: index.Item,
        label: index.ItemName,
        itemCheck: index.selectCheck
    }));

    const ItemDropdownOptions = Item.filter((index) => {
        return index.itemCheck === true
    });

    /* -------------------- ADD ITEM -------------------- */
    const AddWastageItemHandler = async () => {
        try {
            if (!selectedItem) {
                customAlert({ Type: 4, Message: "Please select Item" });
                return;
            }
            const jsonBody = JSON.stringify({
                Party: _cfunc.loginPartyID(),
                ItemID: selectedItem.value,
                BatchCode: "",
                Customer: commonPartyDropSelect.value,
            });
            // 🔥 DIRECT API CALL (SAME AS PURCHASE RETURN)
            setAddItemLoading(true);
            const response = await apiCall.SalesReturn_add_button_api_For_Item(jsonBody);

            if (!response || !response.Data || response.Data.length === 0) {
                customAlert({ Type: 3, Message: "Item details not found" });
                return;
            }

            const item = response.Data[0];

            // 🔑 BUILD GRID ROW FROM API (NOT DROPDOWN)
            setItemGrid(prev => {
                const exists = prev.some(r => r.ItemID === item.Item);
                if (exists) {
                    customAlert({ Type: 3, Message: "Item already added" });
                    return prev;
                }
                const MRPOptions = (item.ItemMRPDetails || []).map(mrp => ({
                    label: mrp.MRPValue,
                    value: mrp.MRP,
                    Rate: mrp.Rate
                }));
                const GSTOptions = (item.ItemGSTDetails || []).map(gst => ({
                    label: gst.GSTPercentage,
                    value: gst.GST,
                }));
                const highestGST = item.ItemGSTDetails?.reduce(
                    (prev, curr) => (prev.GST > curr.GST ? prev : curr),
                    {}
                );
                const highestMRP = item.ItemMRPDetails?.reduce(
                    (prev, current) => (prev.MRP > current.MRP ? prev : current),
                    {}
                );

                return [
                    ...prev,
                    {
                        id: Date.now(),
                        ItemID: item.Item,
                        ItemName: item.ItemName,
                        UnitID: item.Unit,
                        UnitName: item.UnitName,
                        UnitOptions: item.UnitDetails || [],   // 🔥 ADD HERE

                        Quantity: 0,
                        MRP: highestMRP?.MRP || "",
                        MRPValue: highestMRP?.MRPValue || "",
                        Rate: Number(highestMRP?.Rate || 0),
                        BaseRate: Number(highestMRP?.Rate || 0),
                        MRPOptions,
                        GST: highestGST?.GST || "",
                        GSTPercentage: highestGST?.GSTPercentage || "",
                        GSTOptions,
                        ItemTotalStock: Array.isArray(item.StockDetails)
                            ? item.StockDetails.reduce(
                                (sum, s) => sum + Number(s.BaseUnitQuantity || 0),
                                0
                            )
                            : 0,

                        // 🔥 ALWAYS INITIALIZE StockDetails
                        StockDetails: item.StockDetails.map(sd => ({
                            ...sd,
                            Qty: "",
                            Rate: sd.Rate,   // 🔥 SAME AS PR
                        })),
                        ItemTotalAmount: 0,
                    },
                ];
            });

            setShowTable(true);
            setSelectedItem(null);

        } catch (error) {
            console.error(error);
            customAlert({
                Type: 3,
                Message: "Failed to fetch item details",
            });
        } finally {
            setAddItemLoading(false)
        }
    };


    /* -------------------- GRID HELPERS -------------------- */
    const updateGrid = (rowId, key, value) => {
        setItemGrid(prev =>
            prev.map(row =>
                row.id === rowId
                    ? { ...row, [key]: value }
                    : row
            )
        );
    };

    useEffect(() => {
        if (!itemGrid.length) {
            dispatch(BreadcrumbShowCountlabel(`Count:0 currency_symbol 0`));
            return;
        }

        const total = itemGrid.reduce(
            (sum, r) => sum + Number(r.ItemTotalAmount || 0),
            0
        );

        dispatch(
            BreadcrumbShowCountlabel(
                `Count:${itemGrid.length} currency_symbol ${total.toLocaleString()}`
            )
        );
    }, [itemGrid]);

    /* -------------------- TABLE COLUMNS -------------------- */
    const columns = useMemo(() => [
        {
            text: "Item Name",
            dataField: "ItemName",
        },

        isSweetAndSnacks && {
            text: "Batch No",
            dataField: "BatchNo",
        },
        {
            text: "Quantity / Unit",
            formatExtraData: { tableList: itemGrid },
            formatter: (cell, row, _key, { tableList }) => (
                <>
                    <div className="mb-2">
                        <CInput
                            id={`returnQty-${row.id}-${_key}`}
                            type="text"
                            cpattern={decimalRegx_3dit}
                            key={row.id}
                            autoComplete="off"
                            style={{ textAlign: "right" }}
                            defaultValue={Number.isFinite(row.Quantity) ? row.Quantity : 0}
                            onChange={(event) => {
                                userChangedRef.current = true;
                                const rawValue = event.target.value;
                                const enteredQty = rawValue === "" || rawValue === "." || isNaN(rawValue) ? 0 : Number(rawValue);
                                const maxStock = Number(row.ItemTotalStock || 0);
                                const qty = Math.min(enteredQty, maxStock);
                                if (isFranchise) {
                                    const qtyNum = Number(rawValue);
                                    // block invalid / huge values
                                    if (!Number.isFinite(qtyNum)) return;
                                    const maxStock = Number(row.ItemTotalStock || qtyNum);
                                    const finalQty = Math.min(qtyNum, maxStock);
                                    setItemGrid(prev =>
                                        prev.map(r =>
                                            r.id === row.id
                                                ? (() => {
                                                    const updated = {
                                                        ...r,
                                                        Quantity: finalQty, // 🔥 STORE NUMBER
                                                    };
                                                    const calc = return_discountCalculate_Franchise(updated);
                                                    updated.ItemTotalAmount =
                                                        Number(calc?.roundedTotalAmount) || 0;
                                                    return updated;
                                                })()
                                                : r
                                        )
                                    );
                                }
                                else if (isSweetAndSnacks) {
                                    setItemGrid(prev =>
                                        prev.map(r =>
                                            r.id === row.id
                                                ? { ...r, Quantity: qty }
                                                : r
                                        )
                                    );
                                    if(mode.edit){const safeEvent = { target: { value: row.Quantity } };
                                    returnQtyOnChange(safeEvent, row, _key);}
                                    returnQtyOnChange(event, row, _key);
                                    setItemGrid(prev =>
                                        prev.map(r =>
                                            r.id === row.id
                                                ? (() => {
                                                    const rate = Number(r.Rate || 0);
                                                    const gstPer = Number(r.GSTPercentage || r.GST || 0);
                                                    const baseAmount = qty * rate;
                                                    const gstAmount = (baseAmount * gstPer) / 100;
                                                    return {
                                                        ...r,
                                                        ItemTotalAmount: Number(
                                                            (baseAmount + gstAmount).toFixed(2)
                                                        )
                                                    };
                                                })()
                                                : r
                                        )
                                    );
                                }

                                else {
                                    if(mode.edit){const safeEvent = { target: { value: row.Quantity } };
                                    returnQtyOnChange(safeEvent, row, _key);}
                                    returnQtyOnChange(event, row, _key);
                                    setItemGrid(prev =>
                                        prev.map(r => {
                                            if (r.id !== row.id) return r;

                                            const qty = Number(r.Quantity || 0);
                                            const rate = Number(r.Rate || 0);
                                            const gstPer = Number(r.GSTPercentage || r.GST || 0);

                                            const baseAmount = qty * rate;
                                            const gstAmount = (baseAmount * gstPer) / 100;

                                            return {
                                                ...r,
                                                ItemTotalAmount: Number((baseAmount + gstAmount).toFixed(2)),
                                            };
                                        })
                                    );
                                }
                            }}
                        />
                    </div>
                    <Select
                        className="react-dropdown mt-1"
                        classNamePrefix="dropdown"
                        defaultValue={{
                            value: row.UnitID,
                            label: row.UnitName
                        }}
                        options={(row.UnitOptions || []).map(u => ({
                            value: u.UnitID,
                            label: u.UnitName,
                            BaseUnitQuantity: u.BaseUnitQuantity,
                            BaseUnitQuantityNoUnit: u.BaseUnitQuantityNoUnit,
                            Rate: u.Rate,
                        }))}
                        onChange={(e) => {
                            if (!e) return;
                            setItemGrid(prev =>
                                prev.map(r =>
                                    r.id === row.id
                                        ? (() => {
                                            const updated = { ...r };
                                            updated.UnitID = e.value;
                                            updated.UnitName = e.label;
                                            if (isSweetAndSnacks) {
                                                const baseRate = Number(r.BaseRate || 0);
                                                const factor = Number(e.BaseUnitQuantity || 1) / Number(e.BaseUnitQuantityNoUnit || 1);

                                                updated.Rate = Number((baseRate * factor).toFixed(2));
                                            }
                                            else {
                                                const baseRate = Number(r.BaseRate || r.Rate || 0);
                                                updated.Rate = Number(
                                                    ((e.BaseUnitQuantity / e.BaseUnitQuantityNoUnit) * baseRate).toFixed(2)
                                                );
                                            }
                                            if (Array.isArray(updated.StockDetails)) {
                                                updated.StockDetails = updated.StockDetails.map(b => ({
                                                    ...b,
                                                    Rate: updated.Rate
                                                }));
                                            }
                                            if (isFranchise) {
                                                // 🔥 Franchise: always use centralized calculator
                                                const calc = return_discountCalculate_Franchise(updated);
                                            
                                                updated.ItemTotalAmount =
                                                    Number(calc?.roundedTotalAmount) || 0;
                                            
                                                updated.GSTAmount =
                                                    Number(calc?.roundedGstAmount) || 0;
                                            }                                            
                                            else if (isSweetAndSnacks) {
                                                const qty = Number(updated.Quantity || 0);
                                                const rate = Number(updated.Rate || 0);
                                                const gstPer = Number(updated.GSTPercentage || updated.GST || 0);
                                                const baseAmount = qty * rate;
                                                const gstAmount = (baseAmount * gstPer) / 100;
                                                updated.ItemTotalAmount = Number((baseAmount + gstAmount).toFixed(2));
                                            }
                                            else {
                                                const qty = Number(updated.Quantity || 0);
                                                const rate = Number(updated.Rate || 0);
                                                const gstPer = Number(updated.GSTPercentage || updated.GST || 0);

                                                const baseAmount = qty * rate;
                                                const gstAmount = (baseAmount * gstPer) / 100;

                                                updated.ItemTotalAmount = Number(
                                                    (baseAmount + gstAmount).toFixed(2)
                                                );
                                            }
                                            return updated;
                                        })()
                                        : r
                                )
                            );
                        }}
                    />
                    <div className="bottom-div">
                        <div>Amount:</div>
                        <div id={`item-TotalAmount-${row.id}-${_key}`}>
                            {_cfunc.amountCommaSeparateFunc(row.ItemTotalAmount)}
                        </div>
                    </div>
                </>
            ),
        },
        {
            text: "MRP",
            dataField: "MRP",
            hidden: !isFranchise,
            formatter: (cell, row) => {
                return (
                    <div style={{ minWidth: "90px" }}>
                        <Select
                            className="react-dropdown"
                            classNamePrefix="dropdown"

                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                            }}
                            value={
                                row.MRP
                                    ? {
                                        value: row.MRP,
                                        label: row.MRPValue,
                                        Rate: row.Rate,
                                    }
                                    : null
                            }
                            options={row.MRPOptions || []}
                            onChange={(e) => {
                                setItemGrid(prev =>
                                    prev.map(r =>
                                        r.id === row.id
                                            ? (() => {
                                                const unit = r.UnitOptions?.find(u => u.UnitID === r.UnitID);
                                                const updated = {
                                                    ...r,
                                                    MRP: e.value,
                                                    MRPValue: e.label,
                                                    Rate: unit
                                                        ? Number(
                                                            ((unit.BaseUnitQuantity / unit.BaseUnitQuantityNoUnit) * e.Rate).toFixed(2)
                                                        )
                                                        : Number(e.Rate),
                                                };

                                                const calc = return_discountCalculate_Franchise(updated);
                                                updated.ItemTotalAmount =
                                                    Number(calc.roundedTotalAmount) || 0;

                                                return updated;
                                            })()
                                            : r
                                    )
                                );
                            }}
                        />
                    </div>
                );
            },
        },
        {
            text: "GST",
            dataField: "GST",
            hidden: !isFranchise,
            formatter: (cell, row) => (
                <div style={{ minWidth: "90px" }}>
                    <Select
                        className="react-dropdown"
                        classNamePrefix="dropdown"
                        isDisabled={true}
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                        value={
                            row.GST
                                ? { value: row.GST, label: row.GSTPercentage }
                                : null
                        }
                        options={row.GSTOptions || []}
                        onChange={(e) => {
                            setItemGrid(prev =>
                                prev.map(r =>
                                    r.id === row.id
                                        ? (() => {
                                            const updated = {
                                                ...r,
                                                GST: e.value,
                                                GSTPercentage: e.label,
                                            };
                                            if (!isFranchise && updated.StockDetails) {
                                                updated.StockDetails.forEach(sd => {
                                                    sd.LiveBatcheGSTID = e.value;
                                                });
                                            }
                                            const calc = return_discountCalculate_Franchise(updated);
                                            updated.ItemTotalAmount =
                                                Number(calc.roundedTotalAmount) || 0;

                                            return updated;
                                        })()
                                        : r
                                )
                            );
                        }}
                    />
                </div>
            ),
        },
        {
            text: "Stock Details",
            hidden: isFranchise,
            formatExtraData: { tableList: itemGrid },
            formatter: (cell, row, _key, { tableList }) => (
                <Table className="table table-bordered mb-1">
                    <Thead>
                        <tr>
                            <th>Batch</th>
                            <th>Stock</th>
                            <th>Qty</th>
                            <th>Rate</th>
                        </tr>
                    </Thead>
                    <Tbody>
                        {row.StockDetails.map((sd) => (
                            <tr key={sd.id}>
                                <td>{sd.BatchCode}</td>
                                <td style={{ textAlign: "right" }}>{sd.BaseUnitQuantity}</td>
                                <td>
                                    <Input
                                        type="text"
                                        id={`batchQty${row.id}-${sd.id}-${_key}`}
                                        autoComplete="off"
                                        defaultValue={sd.Qty}
                                        onChange={(event) => {
                                            userChangedRef.current = true;
                                            if (isFranchise) return;
                                            if (isSweetAndSnacks) {
                                                sd.GST = row.GSTPercentage || row.GST;
                                            }
                                            stockQtyOnChange(event, row, sd, _key);
                                            innerStockCaculation(row, _key);
                                            setItemGrid(prev => [...prev]);
                                            setForceReload(v => !v);
                                        }}
                                    />
                                </td>
                                <td>{sd.Rate}</td>
                            </tr>
                        ))}
                    </Tbody>
                </Table>
            ),
        },
        {
            text: "Item Remark",
            dataField: "Item Remark",
            formatter: (_, row) => (
                <Input
                    type="text"
                    value={row.ItemRemark}
                    onChange={(e) =>
                        updateGrid(row.id, "ItemRemark", e.target.value)
                    }
                />
            ),
        },

        {
            text: "Action",
            formatter: (_, row) => (
                <Button
                    color="danger"
                    size="sm"
                    onClick={() =>
                        setItemGrid(prev => prev.filter(r => r.id !== row.id))
                    }
                >
                    Delete
                </Button>
            ),
        },
    ].filter(Boolean), [isSweetAndSnacks]);


    const buildWastageItems = () => {
        const items = [];
        const errors = [];

        itemGrid.forEach(item => {
            const qty = Number(item.Quantity || 0);
            const rate = Number(item.Rate || 0);
            const gstPer = Number(item.GSTPercentage || item.GST || 0);
            const baseAmount = qty * rate;
            const gstAmount = (baseAmount * gstPer) / 100;
            const totalAmount = baseAmount + gstAmount;
            if (isFranchise) {
                if (Number(item.Quantity) > 0) {

                    items.push({
                        ItemID: item.ItemID || item.Item,
                        BatchId: null,
                        BatchNo: "",
                        Quantity: Number(item.Quantity),
                        Unit: item.UnitID,
                        Rate: Number(item.Rate || 0),
                        Amount: totalAmount.toFixed(2),
                        Remarks: item.ItemRemark || "",
                        MRP: item.MRP,
                        MRPValue: item.MRPValue,
                        GST: item.GST,
                        GSTPercentage: item.GSTPercentage,
                        GSTAmount: gstAmount.toFixed(2),
                    });
                }
                return;
            }
            item.StockDetails.forEach(sd => {
                if (Number(sd.Qty) > 0) {

                    // 🔥 SAME AS PURCHASE RETURN (NON-FRANCHISE)
                    const calc = return_discountCalculate_Func(sd, item);

                    items.push({
                        ItemID: item.ItemID,
                        BatchId: sd.id,
                        BatchNo: sd.BatchCode,
                        Quantity: Number(sd.Qty),
                        Unit: item.UnitID ?? editData?.Data?.UnitId,
                        Rate: Number(sd.Rate),
                        Amount: totalAmount.toFixed(2),
                        Remarks: item.ItemRemark || "",
                        MRP: item.MRP,
                        MRPValue: item.MRPValue,
                        GST: item.GST,
                        GSTPercentage: item.GSTPercentage,
                        GSTAmount: gstAmount.toFixed(2),
                    });
                }
            });
        });
        return { items, errors };
    };



    const SaveHandler = () => {
        const { items, errors } = buildWastageItems(itemGrid);
        const GrandTotal = calculateGrandTotalFromGrid(itemGrid)
        if (errors.length > 0) {
            customAlert({ Type: 4, Message: errors });
            return;
        }

        if (!isEditMode && items.length === 0) {
            customAlert({ Type: 4, Message: "Wastage Qty is required" });
            return;
        }

        // 🗑️ No items in EDIT → DELETE RECORD
        if (isEditMode && items.length === 0) {
            customAlert({
                Type: 7,
                Message: "All items removed. Do you want to delete this record?",
            }).then((confirmed) => {
                if (confirmed) {
                    dispatch(deleteWastageId({
                        deleteId: editId
                    }));
                }
            });
            return;
        }
        if (isEditMode) {

            dispatch(updateWastageList({   // 🔥 existing wastage ID
                id: editId,
                data: {
                    WastageDate: wastageDate,
                    PartyID: commonPartyDropSelect.value,
                    Remarks: remarks,
                    WastageNo: editData?.Data?.WastageNo,
                    WastagefullNumber: editData?.Data?.WastagefullNumber,
                    CreatedBy: _cfunc.loginUserID(),
                    UpdatedBy: _cfunc.loginUserID(),
                    Items: items,
                    GrandTotal: GrandTotal,
                }
            }));
        } else {
            dispatch(wastageSave({
                WastageDate: wastageDate,
                PartyID: commonPartyDropSelect.value,
                Remarks: remarks,
                CreatedBy: _cfunc.loginUserID(),
                UpdatedBy: _cfunc.loginUserID(),
                Items: items,
                GrandTotal: GrandTotal,
            }));
        }
    };

    /* -------------------- RENDER -------------------- */
    return (
        <React.Fragment>
            <MetaTags>{_cfunc.metaTagLabel(userPageAccessState)}</MetaTags>
            <PageLoadingSpinner isLoading={partyItemListLoading} />

            {/* HEADER */}
            <div className="px-2 c_card_filter text-black">
                <div className="row">

                    <Col lg="3">
                        <FormGroup className="row">
                            <Label className="col-4 mt-3 mb-1">Wastage Date</Label>
                            <Col className="col-7 mt-2 mb-2">
                                <C_DatePicker
                                    value={wastageDate}
                                    onChange={([date]) => {
                                        if (!date) return;

                                        const yyyy = date.getFullYear();
                                        const mm = String(date.getMonth() + 1).padStart(2, "0");
                                        const dd = String(date.getDate()).padStart(2, "0");

                                        setWastageDate(`${yyyy}-${mm}-${dd}`);
                                    }}
                                />
                            </Col>
                        </FormGroup>
                    </Col>

                    <Col lg="4">
                        <FormGroup className="row">
                            <Label className="col-2 mt-3 mb-1">Remarks</Label>
                            <Col className="col-6 mt-2 mb-2">
                                <Input
                                    value={remarks}
                                    onChange={(e) => setRemarks(e.target.value)}
                                    placeholder="Enter Remarks"
                                />
                            </Col>
                        </FormGroup>
                    </Col>

                    <Col lg="3">
                        <FormGroup className="row">
                            <Label className="col-2 mt-3 mb-1 ms-n5">Item</Label>
                            <Col className="col-7 mt-2 mb-2">
                                <C_Select
                                    name="ItemName"
                                    className="react-dropdown"
                                    classNamePrefix="dropdown"
                                    value={selectedItem}
                                    options={ItemDropdownOptions}
                                    isLoading={partyItemListLoading}
                                    onChange={setSelectedItem}
                                    isSearchable={true}
                                    styles={{
                                        menu: provided => ({ ...provided, zIndex: 2 })
                                    }}
                                />
                            </Col>
                        </FormGroup>
                    </Col>

                    <Col lg="2" className="text-end mt-2 mb-2 ms-n5">
                        <Button
                            color="primary"
                            onClick={AddWastageItemHandler}
                            disabled={addItemLoading}
                        >
                            {addItemLoading ? (
                                <>
                                    <span
                                        className="spinner-border spinner-border-sm me-2"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    Adding...
                                </>
                            ) : (
                                "Add"
                            )}
                        </Button>

                    </Col>

                </div>
            </div>

            {/* TABLE */}
            {showTable && (
                <div className="mt-3">
                    <GlobalCustomTable
                        keyField="id"
                        data={itemGrid}
                        columns={columns}
                        classes="table table-bordered table-hover"
                        noDataIndication={
                            <div className="text-danger text-center">
                                Record Not available
                            </div>
                        }
                    />
                </div>
            )}
            {showTable && (
                <SaveButtonDraggable>
                    <SaveButton
                        pageMode={isEditMode ? mode.edit : mode.defaultsave}
                        onClick={SaveHandler}
                        userAcc={userPageAccessState}
                        module={"WastageEnterMaster"}
                        loading={reducers.loading}
                    />
                </SaveButtonDraggable>
            )}
        </React.Fragment>
    );
};

export default WastageEntryMaster;
